// src/services/userService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  //USER_DETAILS,
  // USER_EDIT,
  // USER_EXPORT,
  USER_LIST,
  ORDER_MANAGEMENT_LIST,
  ORDER_DETAILS,
  ORDER_EXPORT,
  ORDER_STAFF_LIST,
  ORDER_UPDATE,
  GET_ORDER_DETAILED_INFO,
  GET_NEW_ORDER_LIST,
  ORDER_STATUS,
  GROUPED_ORDER_STATUS_CHANGE,
  GET_GROUPED_ORDER_INFO,
  CANCEL_ORDER,
  GET_GROUPED_ORDER_INFO_SINGLE,
  SAVE_INGREDIENTS,
  groupedOrder,
} from "../../config/constants"; // Adjust endpoints as per your config

const orderService = createApi({
  reducerPath: "orderService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Order"],
  endpoints: (builder) => ({
    getOrder: builder.query({
      query: (bodyData) => ({
        url: ORDER_MANAGEMENT_LIST, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),
    getGroupedOrderInfo: builder.query({
      query: (bodyData) => ({
        url: GET_GROUPED_ORDER_INFO, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),
    getGroupedSingleOrderInfo: builder.query({
      query: (data) => ({
        url: `${GET_GROUPED_ORDER_INFO_SINGLE}`, // Endpoint to fetch user list
        method: "POST",
        data: data, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),

    getOrderNew: builder.query({
      query: (bodyData) => ({
        url: GET_NEW_ORDER_LIST, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),
    // getOrderDetails: builder.query({
    //   query: (id) => ({
    //     url: `${ORDER_DETAILS}/${id}`, // Endpoint to fetch user details
    //     method: "GET",
    //   }),
    //   providesTags : ["Order"]
    // }),
    getOrderDetails: builder.query({
      query: (data) => ({
        url: `${GET_ORDER_DETAILED_INFO}`, // Endpoint to fetch user details
        method: "POST",
        data: data,
      }),
      providesTags: ["OrderDetail"],
    }),

    getStaffOrder: builder.query({
      query: (bodyData) => ({
        url: ORDER_STAFF_LIST, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),

    // addUser: builder.mutation({
    //   query: (userData) => ({
    //     url: USER_ADD, // Endpoint to add a user
    //     method: "POST",
    //     data: userData, // User data for the request body
    //   }),
    //   invalidatesTags: ["User"],
    // }),

    updateOrder: builder.mutation({
      query: ({ userId, updatedData }) => ({
        url: `${ORDER_UPDATE}/${userId}`, // Endpoint to update a user
        method: "PUT",
        data: updatedData, // Updated user data
      }),
      invalidatesTags: ["Order"],
    }),
    updateGroup: builder.mutation({
      query: ({ userId, updatedData }) => ({
        url: `${groupedOrder}/${userId}`, // Endpoint to update a user
        method: "PUT",
        data: updatedData, // Updated user data
      }),
      invalidatesTags: ["Order"],
    }),

    // deleteUser: builder.mutation({
    //   query: (userId) => ({
    //     url: `${USER_DELETE}/${userId}`, // Endpoint to delete a user
    //     method: "DELETE",
    //   }),
    //   invalidatesTags: ["User"],
    // }),

    saveIngredients: builder.mutation({
      query: (bodyData) => ({
        url: SAVE_INGREDIENTS, // Endpoint to fetch ingredient list
        method: "PUT",
        data: bodyData,
      }),
      invalidatesTags: ["Order"],
    }),

    getOrderExportFile: builder.mutation({
      query: (bodyData) => ({
        url: ORDER_EXPORT, // Endpoint to fetch ingredient list
        method: "POST",
        data: bodyData,
      }),
    }),
    changeMealStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: ORDER_STATUS + id, // Endpoint to fetch ingredient list
        method: "PUT",
        data: data, // Pass the body data for the request
      }),
      invalidatesTags: ["Order"],
    }),
    changeGroupedOrderStatus: builder.mutation({
      query: ({ data, id }) => ({
        url: GROUPED_ORDER_STATUS_CHANGE + id, // Endpoint to fetch ingredient list
        method: "PUT",
        data: data, // Pass the body data for the request
      }),
      invalidatesTags: ["Order", ""],
    }),
    changeStoreOrderStatus: builder.mutation({
      query: ({ data, id }) => ({
        url: GROUPED_ORDER_STATUS_CHANGE + id, // Endpoint to fetch ingredient list
        method: "PUT",
        data: data, // Pass the body data for the request
      }),
      invalidatesTags: ["Order"],
    }),
   
    cancelOrder: builder.mutation({
      query: (data) => ({
        url: CANCEL_ORDER, // Endpoint to fetch ingredient list
        method: "POST",
        data: data,
      }),
      invalidatesTags: ["Order"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetOrderQuery,
  useGetOrderNewQuery,
  useGetStaffOrderQuery,
  useGetOrderDetailsQuery,
  useSaveIngredientsMutation,
  useGetOrderExportFileMutation,
  useUpdateOrderMutation,
  useGetGroupedOrderInfoQuery,
  useGetGroupedSingleOrderInfoQuery,
  //useGetUsersQuery,
  //useGetUserDetailsQuery,
  // useAddUserMutation,
  //useUpdateUserMutation,
  // useDeleteUserMutation,
  //useGetUsersExportFileMutation,
  useChangeMealStatusMutation,
  useChangeGroupedOrderStatusMutation,
  useChangeStoreOrderStatusMutation,
  useCancelOrderMutation,
  useUpdateGroupMutation,
} = orderService;

// Export the reducer to be included in the store
export default orderService;
